import { Spinner } from "@/components/ui/spinner";

const Loading = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-[#FFFEFD]">
      <Spinner className="size-8" />
    </div>
  );
};

export default Loading;
